import { apiRequest, ApiError } from './client';

// Admin: every customer's bookings with supplier price, sale price and profit; change requests; profit reports.

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5062').replace(/\/$/, '');

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.set(key, value);
  });
  const text = search.toString();
  return text ? `?${text}` : '';
};

/** filters: { product, status, supplier, from, to, search, page, pageSize } → { bookings, page, pageSize, totalCount, totals }. */
export const adminListBookings = (token, filters) => apiRequest(`/api/admin/bookings${query(filters)}`, { token });

/** { booking, payments, amendments } */
export const adminGetBooking = (token, id) => apiRequest(`/api/admin/bookings/${id}`, { token });

/** changes: { status?, customerRefund?, supplierRefund? } */
export const adminUpdateBooking = (token, id, changes) =>
  apiRequest(`/api/admin/bookings/${id}`, { method: 'PATCH', body: changes, token });

/** Downloads the filtered bookings as a CSV file. */
export async function adminDownloadBookingsCsv(token, filters) {
  const { page, pageSize, ...rest } = filters || {};
  const response = await fetch(`${API_BASE_URL}/api/admin/bookings/export${query(rest)}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new ApiError(`The export failed (HTTP ${response.status}).`, response.status);
  const url = URL.createObjectURL(await response.blob());
  const link = document.createElement('a');
  link.href = url;
  link.download = `bookings-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/** { from, to, product } → { totals, failedBookings, byProduct, bySupplier, byPeriod, period, amendments } */
export const adminProfitReport = (token, params) => apiRequest(`/api/admin/reports/profit${query(params)}`, { token });

/** { status, product, search, page, pageSize } → { amendments: [{ request, customerName, … }], counts, totalCount, … } */
export const adminListAmendments = (token, params) => apiRequest(`/api/admin/amendments${query(params)}`, { token });

export const adminGetAmendment = (token, id) => apiRequest(`/api/admin/amendments/${id}`, { token });

/** update: { status, message?, charges?, notifyCustomer } */
export const adminRespondToAmendment = (token, id, update) =>
  apiRequest(`/api/admin/amendments/${id}/respond`, { body: update, token });
